/* Silo Digital — article table of contents with scroll-spy.
   Builds a nested H2/H3 TOC from the content element. H3 sublists sit under
   their H2 and only the active H2's sublist is expanded while reading (the
   COTR pattern). On mobile the whole TOC collapses behind a toggle button.
   Hides itself (and collapses the two-column layout) when there are fewer
   than 2 H2s. */
(function () {
  var MOBILE_MQ = window.matchMedia('(max-width: 1023.98px)');

  class SdArticleToc extends HTMLElement {
    connectedCallback() {
      this.contentEl = document.querySelector(this.getAttribute('content-selector') || '.article-content');
      this.offset = parseInt(this.getAttribute('data-sticky-offset') || '100', 10);
      if (!this.contentEl) { this.disable(); return; }
      this.tree = this.collect();
      if (this.tree.length < 2) { this.disable(); return; }
      this.build();
      this.initToggle();
      this.spy();
    }

    disable() {
      this.hidden = true;
      var layout = this.closest('.sd-article__layout');
      if (layout) { layout.classList.add('sd-article__layout--full'); }
    }

    slug(text, i) {
      return 'sd-sec-' + (i + 1) + '-' + text.trim().toLowerCase()
        .replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '').slice(0, 40);
    }

    collect() {
      var self = this;
      var tree = [];
      var all = Array.prototype.slice.call(this.contentEl.querySelectorAll('h2, h3'))
        .filter(function (h) { return h.textContent.trim().length; });
      all.forEach(function (h, i) {
        if (!h.id) { h.id = self.slug(h.textContent, i); }
        h.style.scrollMarginTop = self.offset + 'px';
        var node = { id: h.id, text: h.textContent.trim(), children: [] };
        if (h.tagName === 'H3' && tree.length) {
          tree[tree.length - 1].children.push(node);
        } else if (h.tagName === 'H2') {
          tree.push(node);
        }
      });
      return tree;
    }

    build() {
      var list = this.querySelector('[data-toc-list]') || this;
      var ol = document.createElement('ol');
      ol.className = 'sd-toc__list';
      this.tree.forEach(function (h, i) {
        var li = document.createElement('li');
        li.className = 'sd-toc__item';
        li.setAttribute('data-toc-item', h.id);
        var a = document.createElement('a');
        a.className = 'sd-toc__link';
        a.href = '#' + h.id;
        a.setAttribute('data-target', h.id);
        var num = document.createElement('span');
        num.className = 'sd-toc__num';
        num.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
        var label = document.createElement('span');
        label.className = 'sd-toc__label';
        label.textContent = h.text;
        a.appendChild(num);
        a.appendChild(label);
        li.appendChild(a);
        if (h.children.length) {
          var sub = document.createElement('ol');
          sub.className = 'sd-toc__sublist';
          h.children.forEach(function (c) {
            var sli = document.createElement('li');
            sli.className = 'sd-toc__subitem';
            var sa = document.createElement('a');
            sa.className = 'sd-toc__sublink';
            sa.href = '#' + c.id;
            sa.setAttribute('data-target', c.id);
            sa.textContent = c.text;
            sli.appendChild(sa);
            sub.appendChild(sli);
          });
          li.appendChild(sub);
        }
        ol.appendChild(li);
      });
      list.innerHTML = '';
      list.appendChild(ol);
      this.items = Array.prototype.slice.call(ol.children);
      this.links = Array.prototype.slice.call(ol.querySelectorAll('a[data-target]'));
    }

    initToggle() {
      var self = this;
      var btn = this.querySelector('.sd-toc__toggle');
      if (!btn) { return; }
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        self.classList.toggle('is-open', !open);
      });
      // Collapse after a jump on mobile so the reader lands on the content
      this.addEventListener('click', function (evt) {
        if (MOBILE_MQ.matches && evt.target.closest('a[data-target]')) {
          btn.setAttribute('aria-expanded', 'false');
          self.classList.remove('is-open');
        }
      });
    }

    /* Mark the active H2 item: highlight it and expand only its H3 sublist.
       An H3 entering the viewport activates its parent H2's item too. */
    setActive(id) {
      var parent = null;
      this.tree.forEach(function (h) {
        if (h.id === id) { parent = h.id; }
        h.children.forEach(function (c) { if (c.id === id) { parent = h.id; } });
      });
      this.links.forEach(function (l) {
        l.classList.toggle('is-active', l.getAttribute('data-target') === id);
      });
      this.items.forEach(function (li) {
        li.classList.toggle('is-current', li.getAttribute('data-toc-item') === parent);
      });
    }

    spy() {
      if (!('IntersectionObserver' in window)) { return; }
      var self = this;
      this.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { self.setActive(e.target.id); }
        });
      }, { rootMargin: '-15% 0px -75% 0px', threshold: 0 });
      var observe = function (h) {
        var el = document.getElementById(h.id);
        if (el) { self.io.observe(el); }
        (h.children || []).forEach(observe);
      };
      this.tree.forEach(observe);
    }

    disconnectedCallback() { if (this.io) { this.io.disconnect(); } }
  }

  if (!customElements.get('sd-article-toc')) {
    customElements.define('sd-article-toc', SdArticleToc);
  }
})();
